import { useEffect, useState } from 'react';

import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { serverApis } from '../../../apis/serverApis';
import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import Title from '../../../components/elements/title/Title';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import List from '../../../components/sections/list/List';

const ProjectServerListPage = () => {
  const { projectId } = useParams();
  const { t } = useTranslation();

  const [gpsList, setGpsList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: gpsRes } = await serverApis.getServers(projectId);
      setGpsList(gpsRes.content);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container>
      {loading ? (
        <Loading />
      ) : error ? (
        <AlertMessage
          severity="error"
          message={t('fetchServerError', { ns: 'notifications' })}
        />
      ) : (
        <section>
          <Breadcrumbs />
          <Title text={t('servers', { ns: 'gps' })} />
          <List data={gpsList} />
        </section>
      )}
    </Container>
  );
};

export default ProjectServerListPage;
